var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtaSection06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 25.5C51 39.5833 39.5833 51 25.5 51C11.4167 51 0 39.5833 0 25.5C0 11.4167 11.4167 0 25.5 0C39.5833 0 51 11.4167 51 25.5Z",
    fill: "#FF715E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2951 25.5C46.2951 14.0152 36.9848 4.70492 25.5 4.70492C14.0152 4.70492 4.70492 14.0152 4.70492 25.5C4.70492 36.9848 14.0152 46.2951 25.5 46.2951V47C13.6259 47 4 37.3741 4 25.5C4 13.6259 13.6259 4 25.5 4C37.3741 4 47 13.6259 47 25.5C47 37.3741 37.3741 47 25.5 47V46.2951C36.9848 46.2951 46.2951 36.9848 46.2951 25.5Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11L29.6958 19.6767L39 20.5492L31.98 26.7841L34.0344 36L26 31.1767L17.9656 36L20.02 26.7841L13 20.5492L22.3042 19.6767L26 11Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaSection06);
export default __webpack_public_path__ + "static/media/cta_section_06.7570139355b6f1b669ce01531379875e.svg";
export { ForwardRef as ReactComponent };